module.exports = __webpack_public_path__ + "static/widget-img-13-d9eb6590e1e964ed5f3ca795c7b3d2c0.png";